import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-edit-popup',
    templateUrl: './edit-popup.component.html',
    styleUrls: ['./edit-popup.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditPopupComponent implements OnInit {

  @Input() data: any = null;

  @Output() closeView = new EventEmitter<any>();
	@Output() confirm = new EventEmitter<any>();

  add: boolean = false;

  close() {
		this.closeView.emit();
	}

  onConfirm() {
    let data = {
      var_name: this.data.var_name,
      value: this.data.item,
      valueCheck: this.data?.valueCheck,
      var_name_check: this.data?.var_name_check
    }
    this.confirm.emit(data);
  }

  constructor() { }

  ngOnInit(): void {
    if (this.data.item) this.add = true;
    else this.add = false;
  }
}
